import { space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const navContainer = style([
  {
    flexGrow: 1,
    minWidth: 0,
    alignSelf: 'flex-end',
  },
]);

export const homeExplorePage = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s24,
});
